const mapDefaultOpts = {
    token: "",
    containerRef: null,
    style: "mapbox://styles/mapbox/streets-v12",
    center: [-24, 42],
    zoom: 1
}

const markerDefaultOpts = {
    id: "",
    icon: null,
    size: 0.5,
    popup: {
        isHover: false,
    }
}

const layerDefaultOpts = {
    id: "",
    camera: {
        center: mapDefaultOpts.center,
        zoom: mapDefaultOpts.zoom,
    } 
}

export {mapDefaultOpts, markerDefaultOpts, layerDefaultOpts}